import script from "./CustomDropdownSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDropdownSelector.vue?vue&type=script&setup=true&lang=js"

import "./CustomDropdownSelector.vue?vue&type=style&index=0&id=c5a4de88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5a4de88"]])

export default __exports__